export const CATEGORY_LABELS_BY_CODE = {
    1: "Tiendas Top",
    2: "Tiendas Light",
    3: "Tiendas Low",
    4: "General",
    5: "Banners",
    6: "Señalización",
    7: "Positive Store",
    8: "Make Up 400",
    9: "Munich",
    10: "Copenhague",
    11: "Miami-Splau",
    12: "Make Up 400 PLUS",
};

const CATEGORY_LABELS_BY_NAME = {
    tiendastop: "Tiendas Top",
    "tiendas top": "Tiendas Top",
    tiendaslight: "Tiendas Light",
    "tiendas light": "Tiendas Light",
    tiendaslow: "Tiendas Low",
    "tiendas low": "Tiendas Low",
    general: "General",
    banner: "Banners",
    banners: "Banners",
    senalizacon: "Señalización",
    senalizacion: "Señalización",
    "señalización": "Señalización",
    positivestore: "Positive Store",
    "positive store": "Positive Store",
    makeup: "Make Up 400",
    "make up": "Make Up 400",
    "make up 400": "Make Up 400",
    makeup400: "Make Up 400",
    "make-up-400": "Make Up 400",
    "make up 400 plus": "Make Up 400 PLUS",
    makeup400plus: "Make Up 400 PLUS",
    "make-up-400-plus": "Make Up 400 PLUS",
    munich: "Munich",
    copenhague: "Copenhague",
    miami: "Miami-Splau",
    "miami-splau": "Miami-Splau",
};

export const normalizeCategoryLabel = (category) => {
    if (category === null || category === undefined) return "";

    const value = String(category).trim();
    if (!value) return "";

    const numericValue = Number(value);
    if (Number.isInteger(numericValue) && CATEGORY_LABELS_BY_CODE[numericValue]) {
        return CATEGORY_LABELS_BY_CODE[numericValue];
    }

    return CATEGORY_LABELS_BY_NAME[value.toLowerCase()] || value;
};

export const formatCategories = (categories) => {
    if (!categories) return "";

    const categoryList = Array.isArray(categories)
        ? categories
        : String(categories).split(",");

    return categoryList
        .map(normalizeCategoryLabel)
        .filter(Boolean)
        .join(", ");
};

export const getCategorySlug = (category) =>
    normalizeCategoryLabel(category)
        .toLowerCase()
        .replace(/\s+/g, "-");
